import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import "lottie-react";
import "../../../../themes/shadows/shadows.js";
import "../../../../themes/typography/typography.js";
import "react";
import "../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../components/dialog/dialog.js";
import "../../../../components/icons/all/all.js";
import "../../../../components/label/label.styles.js";
import "../../../../components/menu-item/menu-item.js";
import { Slider } from "../../../../components/slider/slider.js";
import "@mui/material/styles";
import "../../../../components/snackbar/snackbar.styles.js";
import "../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../components/translations/utils.js";
import "../../../../components/time-select/time-select.styles.js";
import "../../../../components/time-interval-select/time-interval-select.styles.js";
import { sliderContainer, sliderLabel } from "../pain-details-form.styles.js";
import "../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../constants/create-theme/create-theme.js";
import "../../../../constants/colors/palette.js";
import "../../../../themes/button/button.js";
import "../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../themes/button/styles/external/filled.styles.js";
import "../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../themes/date-calendar/date-calendar.js";
import "../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../themes/day-calendar/day-calendar.js";
import "../../../../themes/filled-input/filled-input.js";
import "../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../themes/form-label/form-label.js";
import "../../../../themes/month-calendar/month-calendar.js";
import "../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../themes/pickers-month/pickers-month.js";
import "../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../themes/pickers-year/pickers-year.js";
import "../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../themes/alert/alert.js";
import "../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../themes/dialog/dialog.js";
import "../../../../themes/external-theme/external-theme.js";
import "../../../../constants/breakpoints/breakpoints.js";
import "../../../../themes/checkbox/checkbox.js";
import "../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../themes/form-control-label/form-control-label.js";
import "../../../../themes/radio/radio.js";
import "../../../../themes/switch/switch.js";
import "../../../../themes/popover/popover.js";
import "../../../../themes/tooltip/tooltip.js";
import "../../../../components/dialog/dialog.constants.js";
import "../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../components/icons/EventNote/EventNote.js";
import "../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../components/menu-item/menu-item.styles.js";
import "../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../components/avatar/avatar.styles.js";
import "@mui/material/Slider/index.js";
import "../../../../components/slider/slider.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../components/snackbar/snackbar.types.js";
import "../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../components/text-field/text-field.styles.js";
import "../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
const mapAnswerToValue = (data, question, step) => {
  const { answers, key } = question;
  const value = data[key];
  return answers.findIndex((answer) => answer.value === value) * step;
};
const mapValueToAnswer = (value, question, step) => {
  const { answers } = question;
  const indexOfAnswer = value / step;
  return answers[indexOfAnswer].value;
};
const SliderAnswer = ({ question, data, handleChange }) => {
  const { answers, key } = question;
  const step = 100 / (answers.length - 1);
  const value = mapAnswerToValue(data, question, step);
  const activeIndex = value / step;
  const marks = answers.map((answer, index) => ({ label: answer.label, value: step * index }));
  const valueLabelFormat = (v) => (v / step + 1).toString();
  const MarkLabel = (props) => {
    const dataIndex = props["data-index"];
    const isActive = dataIndex === activeIndex;
    const shouldHideLabel = dataIndex !== 0 && dataIndex !== answers.length - 1 && !isActive;
    return /* @__PURE__ */ jsx(
      Box,
      {
        component: "span",
        className: props.className,
        sx: {
          ...props.style,
          ...sliderLabel(isActive, shouldHideLabel)
        },
        children: props.children
      }
    );
  };
  return /* @__PURE__ */ jsx(Box, { sx: sliderContainer, children: /* @__PURE__ */ jsx(
    Slider,
    {
      value,
      marks,
      step,
      valueLabelDisplay: "auto",
      getAriaValueText: valueLabelFormat,
      valueLabelFormat,
      onChange: (_, newValue) => handleChange(key, mapValueToAnswer(newValue, question, step)),
      slots: {
        markLabel: MarkLabel
      }
    }
  ) });
};
export {
  SliderAnswer
};
